import { setIsInternalClinic, setOriginalClinicId, useConfig, useConfigDispatch } from '@context/ConfigurationContext'
import { useEffect } from 'react'
import { useQuery } from 'react-query'
import { getClinic } from 'src/services/api/clinic'

export const useSetOriginalClinicId = (isVisible: boolean) => {
  const configDispatch = useConfigDispatch()
  const { clinicId, originalClinicId } = useConfig()

  useEffect(() => {
    if (clinicId && !originalClinicId && isVisible) {
      configDispatch(setOriginalClinicId(clinicId))
    }
  }, [clinicId, configDispatch, originalClinicId, isVisible])

  useQuery(['clinicTenantType', clinicId], () => getClinic(clinicId), {
    retry: 3,
    enabled: !!clinicId,
    onSuccess(data: { isTenantInternal: boolean }) {
      const { isTenantInternal } = data

      configDispatch(setIsInternalClinic(isTenantInternal))
    },
  })
}
